import * as React from 'react';
import classNames from 'classnames';

import { Icon } from '@lumapps/lumx/react';
import { mdiNumeric1Box, mdiNumeric2Box } from '@lumapps/lumx/icons';

/**
 * Renders a color item for the `ColorPalette`.
 */
export class ColorPaletteItem extends React.PureComponent {
    render() {
        const { value, selected, primary, accent, onClick } = this.props;

        return (
            <div
                id={value}
                className={classNames('color-palette__color', selected && 'color-palette__color--is-selected')}
                onClick={onClick}
            >
                <div className="color-palette__color-wrapper">
                    {primary && (
                        <div className="color-palette__color-indicator">
                            <Icon icon={mdiNumeric1Box} size="xs" color="light" />
                        </div>
                    )}
                    {accent && (
                        <div className="color-palette__color-indicator">
                            <Icon icon={mdiNumeric2Box} size="xs" color="light" />
                        </div>
                    )}
                    <div className="color-palette__color-background" style={{ backgroundColor: value }} />
                    <span className="color-palette__color-label">{value}</span>
                </div>
            </div>
        );
    }
}
